export default __webpack_public_path__ + "static/media/icon-send.dd942669.svg";